import store from "../shop/store";
import { setCookie, getCookie, deleteCookie } from "../util/dom";
import { fetchVoyadoContactId } from "../components/voyado";
var voyadoTrackingEnabled = $('body').hasClass('web-tracking-enabled'),
  emailFieldUpdateTimeoutDuration = 1000;
;
var emailFieldUpdateTimeout = null,
  emailPreviousValue = typeof store.getState().payment.address.email === "undefined" ? null : store.getState().payment.address.email,
  cartPreviousTotalQuantity = typeof store.getState().selection.totals === "undefined" ? null : store.getState().selection.totals.totalQuantity;
var init = function init() {
  if (!voyadoTrackingEnabled) return;
  store.subscribe(function () {
    trackEmail();
    trackCartChanges();
  });

  // Track checkout page
  if (document.body.classList.contains('template-checkout')) {
    cartUpdate();
  }

  // Track product page view and variant change
  if (document.body.classList.contains('single-silk_products-data')) {
    var product = $('section.js-product-info').data('product');
    productView(product);
  }
};

// Track changes to cart
var trackCartChanges = function trackCartChanges() {
  if (typeof store.getState().selection.totals === "undefined") return;
  if (cartPreviousTotalQuantity === store.getState().selection.totals.totalQuantity) return;
  cartPreviousTotalQuantity = store.getState().selection.totals.totalQuantity;
  cartUpdate();
};

// Track changes to email property
var trackEmail = function trackEmail() {
  if (typeof store.getState().payment.address.email === "undefined") return;
  if (emailFieldUpdateTimeout) clearTimeout(emailFieldUpdateTimeout);
  emailFieldUpdateTimeout = setTimeout(function () {
    var email = store.getState().payment.address.email;
    if (emailPreviousValue === email || !email) return;
    emailPreviousValue = email;
    fetchVoyadoContactId(email).then(function (data) {
      assignContact(data.id);
    });
  }, emailFieldUpdateTimeoutDuration);
};
var productView = function productView(itemId) {
  if (!voyadoTrackingEnabled) return;
  if (typeof va === 'undefined') return;
  if (typeof itemId === 'undefined' || !itemId) return;
  var item = null;
  if (store.getState().productCache.items && store.getState().productCache.items[itemId] !== 'undefined') {
    item = store.getState().productCache.items[itemId];
  }
  if (!item) return;
  var sku = item.sizes[0].hasOwnProperty('sku') ? item.sizes[0].sku : false;
  if (!sku) return;
  va('productview', {
    'categoryName': item.categories.length > 0 ? item.categories[0] : '',
    // required
    'itemId': sku
  });
};
var cartUpdate = function cartUpdate() {
  if (!voyadoTrackingEnabled) return;
  if (typeof va === 'undefined') return;
  var items = store.getState().selection.items;
  var voyadoItems = [];
  if (!items) return;
  items.forEach(function (item) {
    var matchedProduct = Object.values(store.getState().productCache.items).filter(function (product) {
      return (item.sku + item.variant).toUpperCase() === product.variantSku.toUpperCase();
    });
    if (matchedProduct.length === 0) return;
    var size = matchedProduct[0].sizes.filter(function (size) {
      return item.size === size.name;
    });
    if (size.length === 0) return;
    voyadoItems.push({
      'itemId': size[0].sku,
      'price': item.priceEach,
      'quantity': item.quantity
    });
  });

  // Generate checkout link
  var checkoutLink = document.querySelector('.cart-footer a'),
    cartRef = store.getState().store.token,
    cartUrl = document.location.href;
  if (checkoutLink) {
    cartUrl = checkoutLink.href;
  }
  cartUrl += '?cartId=' + cartRef;
  va('cart', {
    'cartRef': cartRef,
    'cartUrl': cartUrl,
    'locale': 'en-US',
    //document.documentElement.lang,
    'items': voyadoItems
  });
  setCookie('voyado_cart_url', cartUrl, 365, 'SameSite=None; Secure');
};
var voyadoPurchase = function voyadoPurchase() {
  if (!voyadoTrackingEnabled) return;
  if (typeof va === 'undefined') return;
  var cartRef = getCookie('voyado_cart_url') || '';
  va('emptyCart', {
    cartRef: cartRef
  }); // This actually calls `cart()` with empty `items`.

  deleteCookie('voyado_cart_url');
};
var assignContact = function assignContact(id) {
  if (!voyadoTrackingEnabled) return;
  if (typeof va === 'undefined') return;
  va("setContactId", id);
};
init();
export { productView };
export default voyadoPurchase;


// WEBPACK FOOTER //
// ./scripts/components/analytics-ca.js